﻿import { ISubscription, Subscription } from 'common/barrels/rx';

export interface IDisposable {
    dispose(): void;
}

export const emptyDisposable = {
    dispose: () => { }
};

export function disposable(f: () => void) {
    let disposed = false;

    return {
        dispose: () => {
            if(!disposed) {
                disposed = true;
                f();
            }
        }
    }
}

export function serialDisposable(d: IDisposable) {
    return {
        dispose: () => (d ? d.dispose : () => { })(),
        set: (f: IDisposable) => {
            if (d)
                d.dispose();

            d = f;
        }
    }
}

export function compositeDisposable(disposables: IDisposable[]): IDisposable {
    return disposable(() => disposables.forEach(x => x.dispose()));
}

export function compositeSubscription(...subs: (ISubscription | IDisposable)[]): Subscription {
    const s = new Subscription();

    subs.forEach(x => {
        if ((<ISubscription>x).unsubscribe)
            s.add((<ISubscription>x));
        else
            s.add({ unsubscribe: () => (<IDisposable>x).dispose() });
    });

    return s;
}

export function disposableSubscription(...subs: (ISubscription | IDisposable)[]): IDisposable {
    return disposable(() => {
        subs.forEach(x => {
            if ((<ISubscription>x).unsubscribe)
                (<ISubscription>x).unsubscribe();
            else
                (<IDisposable>x).dispose();
        });
    });
}